__turbopack_context__.v({
  "root": "BooleanFormatter-module__goC1KG__root",
});
